import styled from 'styled-components';
import Colors from 'library/constants/colors';
import Logo from 'assets/images/logo';
import { Title } from 'library/styles/text';
import { ButtonStyles } from '../../library/styles/button';

export const StyledTitle = styled(Title)`
  display: inline-block;
`;

export const StyledLogo = styled(Logo)`
  background-image: url(${Logo});
  width: 250px;
  min-height: 60px;
}
`;

export const Container = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;
  justify-content: space-between;
  align-items: center;
  height: 100vh;
  width: 100%;
`;

export const ConfirmButton = styled.button`
  ${ButtonStyles};
  width: ${(props) => props.submitWidth};
  background-color: ${Colors.violetLight};
  margin-top: 20px;
  color: #fff;

  &:hover {
    &:before {
      opacity: 0.3;
    }
  }

  &:disabled {
    color: #fff !important;

    &:before {
      background-color: #CDDADE !important;
      opacity: 0.5;
    }
  }
`;

export const TextContainer = styled.div`
  display: flex;
  align-items: inherit;
  justify-content: space-between;
  width: 100%;
  max-width: 220px;
  margin: 0 auto;
`;

export const StyledForm = styled.form`
  width: 600px;
  padding: 40px;
  height: auto;
  min-height: 300px;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
